var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2806 14.2194C15.3502 14.289 15.4055 14.3718 15.4432 14.4628C15.4809 14.5539 15.5003 14.6514 15.5003 14.75C15.5003 14.8485 15.4809 14.9461 15.4432 15.0372C15.4055 15.1282 15.3502 15.2109 15.2806 15.2806C15.2109 15.3503 15.1281 15.4056 15.0371 15.4433C14.9461 15.481 14.8485 15.5004 14.7499 15.5004C14.6514 15.5004 14.5538 15.481 14.4628 15.4433C14.3717 15.4056 14.289 15.3503 14.2193 15.2806L7.99993 9.0603L1.78055 15.2806C1.63982 15.4213 1.44895 15.5004 1.24993 15.5004C1.05091 15.5004 0.860034 15.4213 0.719304 15.2806C0.578573 15.1399 0.499512 14.949 0.499512 14.75C0.499512 14.551 0.578573 14.3601 0.719304 14.2194L6.93962 7.99999L0.719304 1.78061C0.578573 1.63988 0.499512 1.44901 0.499512 1.24999C0.499512 1.05097 0.578573 0.860095 0.719304 0.719365C0.860034 0.578634 1.05091 0.499573 1.24993 0.499573C1.44895 0.499573 1.63982 0.578634 1.78055 0.719365L7.99993 6.93968L14.2193 0.719365C14.36 0.578634 14.5509 0.499573 14.7499 0.499573C14.949 0.499573 15.1398 0.578634 15.2806 0.719365C15.4213 0.860095 15.5003 1.05097 15.5003 1.24999C15.5003 1.44901 15.4213 1.63988 15.2806 1.78061L9.06024 7.99999L15.2806 14.2194Z",
    fill: "white",
    fillOpacity: 0.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b2f2c6f1d343f2cf9e1542b2a987811f.svg";
export { ForwardRef as ReactComponent };